export default "__VITE_ASSET__BhcIYFDL__"